// Desbloqueio do app pela digital / Face ID do próprio celular (WebAuthn, autenticador da plataforma).
// A biometria é conferida pelo sistema do celular — o DigiPonto nunca recebe nem guarda digital ou rosto.
// Como o PIN, é uma trava de acesso ao app no aparelho (a sessão continua protegida pelo login).
const KEY = "digiponto_app_bio";

const b64 = (buf) => btoa(String.fromCharCode(...new Uint8Array(buf)));
const deB64 = (s) => Uint8Array.from(atob(s), (c) => c.charCodeAt(0));
const aleatorio = (n) => crypto.getRandomValues(new Uint8Array(n));
const ler = () => { try { return JSON.parse(localStorage.getItem(KEY) || "null"); } catch (_) { return null; } };

export const appBio = {
  async disponivel() {
    try {
      return !!(window.PublicKeyCredential
        && await window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable());
    } catch (_) { return false; }
  },

  isSet: (appUserId) => {
    const c = ler();
    return !!c && (!appUserId || c.app_user_id === appUserId);
  },

  async ativar(session) {
    const nome = session?.app_user?.username || session?.funcionario?.nome || "funcionario";
    const cred = await navigator.credentials.create({
      publicKey: {
        rp: { name: "DigiPonto", id: window.location.hostname },
        user: { id: aleatorio(16), name: nome, displayName: session?.funcionario?.nome || nome },
        challenge: aleatorio(32),
        pubKeyCredParams: [{ type: "public-key", alg: -7 }, { type: "public-key", alg: -257 }],
        authenticatorSelection: { authenticatorAttachment: "platform", userVerification: "required", residentKey: "discouraged" },
        timeout: 60000,
        attestation: "none",
      },
    });
    if (!cred) throw new Error("Cadastro da biometria cancelado");
    localStorage.setItem(KEY, JSON.stringify({ id: b64(cred.rawId), app_user_id: session?.app_user?.id }));
  },

  async verificar() {
    const c = ler();
    if (!c) return true;
    const a = await navigator.credentials.get({
      publicKey: {
        challenge: aleatorio(32),
        rpId: window.location.hostname,
        allowCredentials: [{ type: "public-key", id: deB64(c.id), transports: ["internal"] }],
        userVerification: "required",
        timeout: 60000,
      },
    });
    // Byte 32 do authenticatorData: bit UV (0x04) = o celular confirmou a digital/rosto
    const flags = a?.response?.authenticatorData ? new Uint8Array(a.response.authenticatorData)[32] : 0;
    if (!a || !(flags & 0x04)) throw new Error("Biometria não confirmada");
    return true;
  },

  clear: () => localStorage.removeItem(KEY),
};
